import directory from "../../directory.json"
const _ = require("lodash")
// var fs = require('fs');

const dir = __dirname

class SlgVueFramework {
    constructor() {
        //this._loadPlugins()
    }

    install(Vue, options) {
        let processed = directory;
        let pluginOptions;
        if (options) {
            if (_.isArray(options)) {
                pluginOptions = options
            } else if (_.isObject(options)) {
                pluginOptions = options.plugins
            }
        }

        if (pluginOptions) {
            processed = directory.filter(plugin => _.includes(pluginOptions, plugin.name))
        } else {
            processed = directory.filter(plugin => plugin.enabled)
        }

        this._loadPlugins(processed).forEach(plugin => {
            Vue.use(plugin)
        })

    }

    _loadPlugins(directory) {
        return directory.map(plugin => this._loadPlugin(plugin.path))
    }

    _getPluginDefinition(name) {
        return directory.find(plugin => plugin.name == name);
    }

    _getPlugin(name) {
        return this._loadPlugin(this._getPluginDefinition(name).path)
    }

    _loadPlugin(path) {
        //Note: Dont change this or it might break webpack imports
        return require("../" + path + "/index.js").default
    }
}

export default new SlgVueFramework();